import { render, staticRenderFns } from "./ContratacaoDetalhesCardDadosBasicos.vue?vue&type=template&id=6e18f936"
import script from "./ContratacaoDetalhesCardDadosBasicos.vue?vue&type=script&lang=js"
export * from "./ContratacaoDetalhesCardDadosBasicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports